import { IWebsiteFont } from '../../interfaces/Website/Banners/IWebsiteFont'
import apiService from '../Api'

export default class WebsiteFontService {
  async list(): Promise<IWebsiteFont[]> {
    return apiService.get('internal/website/banner-fonts').then(({ data }) => data.data)
  }

  async create(name: string, file: File, sizeAdjust: number): Promise<IWebsiteFont> {
    const formData = new FormData()
    formData.append('name', name)
    formData.append('file', file)
    formData.append('size_adjust', String(sizeAdjust))

    return apiService
      .post('internal/website/banner-fonts', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(({ data }) => data.data)
  }

  /** Nome e ajuste de tamanho. O arquivo e o slug não mudam: trocar o arquivo é enviar outra fonte. */
  async update(id: number, name: string, sizeAdjust: number): Promise<IWebsiteFont> {
    return apiService
      .put(`internal/website/banner-fonts/${id}`, { name, size_adjust: sizeAdjust })
      .then(({ data }) => data.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`internal/website/banner-fonts/${id}`)
  }
}
